module.exports = __webpack_public_path__ + "static/media/10-metros-en-horizontal.0ba31cfb.svg";